import { useTranslation } from "react-i18next";
import Button from "../Button/Button";
import { HiOutlineArrowRight } from "react-icons/hi";
const VideoBanner = ({ title, description, buttonTitle }) => {
  const { i18n } = useTranslation();
  const html = document.getElementsByTagName("html")[0].dir;
  return (
    <section
      className="container flex flex-col justify-center items-center pb-16 pt-8 md:py-20"
      id="videoBanner"
    >
      <div className="grid lg:grid-cols-5 grid-cols-1 md:gap-20 gap-10 items-center w-full">
        <div
          className={`${
            i18n.language === "ar" ? "text-right" : "text-left"
          } flex flex-col justify-center h-full md:col-span-2`}
        >
          <h1
            aria-level={1}
            className={`${
              i18n.language === "ar" ? "lg:text-right" : "lg:text-left"
            } text-center md:leading-tight lg:max-w-md`}
          >
            {title}
          </h1>
          <p
            className={`${
              i18n.language === "ar" ? "lg:text-right" : "lg:text-left"
            } !text-secondary-650 text-center my-3`}
          >
            {description}
          </p>
          <div className="w-full flex lg:justify-start mt-3 justify-center">
            <Button
              className="gap-4"
              onClick={() => {
                window.location.href = `/${i18n.language}`;
              }}
              iconEnd={
                <HiOutlineArrowRight
                  className={`${html === "rtl" && "rotate-180"} text-lg`}
                />
              }
              value={buttonTitle}
            />
          </div>
        </div>
        <div className="md:col-span-3 h-80 sm:h-[28rem]">
          <iframe
            className="rounded-3xl flex-shrink-0"
            width="100%"
            height="100%"
            src="https://www.youtube.com/embed/KZUNpNFCF2U"
            title="YouTube video player"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
          ></iframe>
        </div>
      </div>
    </section>
  );
};
export default VideoBanner;
